module.exports = __webpack_public_path__ + "img/protect2.4dba48dd.png";